.board {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-3);
}
